/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { countryHead } from "../../../../../config/constant";
import { Image, Space } from "antd";
import { NavLink } from "react-router-dom"
import EditIcon from "../../../../../assets/images/icon_actions/Edit.svg";
import DeleteIcon from "../../../../../assets/images/icon_actions/Delete Icon.svg";
import { PrimaryDrawer } from "../../../../Shared/components/Drawer/PrimaryDrawer";
import customStyles from "../../../../../assets/styles/customStyles";
import { TableCell, TableRow, Button, Box, TextField } from "@mui/material";
import clsx from "clsx";
import crudActions from "../../../../CRUD/redux/actions";
import { useDispatch, useSelector } from "react-redux";
import { toast } from 'react-toastify';
import usePrevious from "../../../../Shared/components/Previous";
import { emptyValidation } from "../../../../../helpers/validation";
import DeleteModal from "../../../../Shared/components/DeleteModal";
import { AutoCompleteComponent } from "../../../../Shared/components/AutoCompleteComponent";
import CustomInfiniteScroll from "../../../../Shared/components/CustomInfiniteScroll";
import { checkCRUDPermission, getColumnWidth } from "../../../../../helpers/utilities";

export const CountryTable = (props) => {

    const { onRequestSort, sortOrder, sortBy, loadTasks, loadMore, loadMoreTask, customObject, 
        loadMoreContent, details, roleManagement } = props;
    const { currencyDetails } = useSelector(state => state.adminSetupReducer);
    const [visible, setVisible] = useState(false);
    const [countryId, setCountryId] = useState(false);
    const [countryName, setCountryName] = useState(false);
    const [longName, setLongName] = useState(false);
    const [currencyId, setCurrencyId] = useState(false);
    const [currencySymbol, setCurrencySymbol] = useState(false);
    const [deleteModal, setDeleteModal] = useState(false);

    const { editDetails, editError, editLoader } = useSelector(state => state.crudReducer);


    const prevEditDetails = usePrevious(editDetails);
    const prevEditError = usePrevious(editError);

    const [errorCountryName, setErrorCountryName] = useState(false);
    const [errorLongName, setErrorLongName] = useState(false);
    const [errorCurrencySymbol, setErrorCurrencySymbol] = useState(false);
    const [errorCurrencyId, setErrorCurrencyId] = useState(false);

    const handleClose = () => {
        setVisible(false);
        emptyState();
    };

    const onEdit = (data) => {
        setVisible(true);
        setCountryId(data.id);
        setCountryName(data.name);
        setLongName(data.longName);
        setCurrencyId(data.currencyId);
        setCurrencySymbol(data?.currency?.symbol);
    }

    const emptyState = () => {
        setErrorCountryName(false);
        setErrorLongName(false);
        setErrorCurrencyId(false);
        setErrorCurrencySymbol(false);
    }

    const dispatch = useDispatch();
    const editCountry = (e) => {
        e.preventDefault();
        let emptyCountryName = emptyValidation('Country Name', countryName);
        let emptyLongName = emptyValidation('Long Name', longName);
        let emptyCurrencyId = emptyValidation('Currency', currencyId, 'dropDown');
        emptyState();
        if (emptyCountryName.isValid && emptyLongName.isValid && emptyCurrencyId.isValid) {
            dispatch({
                type: crudActions.EDIT_DETAILS_START,
                url: "country",
                title: "Country",
                id: countryId,
                details: {
                    name: countryName,
                    longName: String(longName),
                    currencyId: currencyId
                }
            });
        } else {
            if (emptyCountryName.errors !== '') {
                setErrorCountryName(emptyCountryName.errors);
            } if (emptyLongName.errors !== '') {
                setErrorLongName(emptyLongName.errors);
            } if (emptyCurrencyId.errors !== '') {
                setErrorCurrencyId(emptyCurrencyId.errors);
            }
        }
    }

    const handleDeleteModal = (value) => {
        setDeleteModal(value);
    }

    useEffect(() => {
        if (prevEditDetails !== undefined && editDetails && prevEditDetails !== editDetails) {
            loadTasks();
            toast.dismiss();
            toast(editDetails);
            setVisible(false);
        } else if (prevEditError !== undefined && editError && prevEditError !== editError) {
            let error = editError.error.message;
            setErrorCountryName(error);
        }
    }, [editDetails, editError]);

    const onDelete = (data) => {
        setDeleteModal(true);
        setCountryName(data.name);
        setCountryId(data.id);
    }

    const changeCurrency = (value) => {
        let currency = currencyDetails.filter(function (el) { return el.id === value });
        setCurrencyId(value);
        if(currency && currency.length > 0) {
            setCurrencySymbol(currency[0].symbol);
        } else {
            setCurrencySymbol('');
        }       
    }


    const classes = customStyles();
    return (
        <>
            <CustomInfiniteScroll
                loadMore={loadMore}
                loadMoreContent={loadMoreContent}
                heads={countryHead}
                onRequestSort={(sortBy, sortOrder) => onRequestSort(sortBy, sortOrder)}
                sortOrder={sortOrder}
                sortBy={sortBy}
                loadMoreTask={() => loadMoreTask()}
                component={
                    <>
                        {
                            !loadMore || details === '' ? (
                                <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                    <TableCell className={classes.textAlignCenter} colSpan={6}><div className={classes.loadMoreCircle}></div></TableCell>
                                </TableRow>
                            ) : (
                                <React.Fragment>
                                    {
                                        details && Array.isArray(details) && details?.length > 0 ? details?.map((data, i) => (
                                            <TableRow key={i} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                                <TableCell style={{ width: getColumnWidth(countryHead, 0) }} key={data.name}><span style={{ width: getColumnWidth(countryHead, 0) }}>{data.name}</span></TableCell>
                                                <TableCell style={{ width: getColumnWidth(countryHead, 1) }}><span style={{ width: getColumnWidth(countryHead, 0) }}>{data.longName ? data.longName : '---'}</span></TableCell>
                                                <TableCell style={{ width: getColumnWidth(countryHead, 2) }}><span style={{ width: getColumnWidth(countryHead, 0) }}>{data?.currency?.name || '---'}</span></TableCell>
                                                <TableCell style={{ width: getColumnWidth(countryHead, 3) }}><span style={{ width: getColumnWidth(countryHead, 0) }}>{data?.currency?.symbol || '---'}</span></TableCell>
                                                <TableCell className={clsx(classes.tableLastColumn)}>
                                                    <Space direction="horizontal" align="center" size={[0, 0]} className={classes.iconPadding}>
                                                        {
                                                            roleManagement !== '' && (checkCRUDPermission('Country', 'edit', 'Younote Admin') || checkCRUDPermission('Country', 'edit', 'Admin')) &&
                                                            <NavLink to={"#"} onClick={() => onEdit(data)}>
                                                                <Image src={EditIcon} preview={false} />
                                                            </NavLink>
                                                        }
                                                        {
                                                            roleManagement !== '' && (checkCRUDPermission('Country', 'deletable', 'Younote Admin') || checkCRUDPermission('Country', 'deletable', 'Admin')) &&
                                                            <NavLink to={"#"} onClick={() => onDelete(data)}>
                                                                <Image src={DeleteIcon} preview={false} />
                                                            </NavLink>
                                                        }
                                                    </Space>
                                                </TableCell>
                                            </TableRow>
                                        )) : (
                                            <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                                <TableCell className={classes.textAlignCenter} colSpan={6}>
                                                    <p className={clsx(classes.noResultsText, classes.textAlignCenter)}>{'Start Creating Country'}</p>
                                                </TableCell>
                                            </TableRow>
                                        )
                                    }
                                </React.Fragment>
                            )
                        }
                    </>
                }
            />
            <PrimaryDrawer
                anchor={'right'}
                open={visible}
                variant={'temporary'}
                handleClose={() => handleClose()}
                title={'Edit Country'}
                width={"360px"}
                className={classes.closeBackGround}
                component={
                    <Box
                        className={clsx(classes.customForm, classes.removeUnderline)}
                        component="form"
                        autoComplete="off"
                        onSubmit={(e) => editCountry(e)}
                    >
                        <div className={classes.customFormFlex}>
                            <TextField autoComplete='one-time-code'
                                label={["Country Name ", <span key={"Country Name"} className={classes.colorRedRequired}> *</span>]}
                                variant={'standard'}
                                error={errorCountryName ? true : false}
                                helperText={errorCountryName}
                                InputProps={{
                                    classes: {
                                        input: classes.textFieldColor,
                                    }
                                }}
                                InputLabelProps={{
                                    className: classes.textFieldLableColorCustom,
                                }}
                                value={countryName}
                                onChange={(e) => setCountryName(e.target.value)}
                            />
                            <TextField autoComplete='one-time-code'
                                label='Long Name'
                                variant={'standard'}
                                error={errorLongName ? true : false}
                                helperText={errorLongName}
                                className={clsx(classes.margin20t)}
                                InputProps={{
                                    classes: {
                                        input: classes.textFieldColor,
                                    }
                                }}
                                InputLabelProps={{
                                    className: classes.textFieldLableColorCustom,
                                }}
                                value={longName}
                                onChange={(e) => setLongName(e.target.value)}
                            />

                            <AutoCompleteComponent
                                name={["Currency ", <span key={"Currency"} className={classes.colorRedRequired}> *</span>]}
                                heads={[{ 'key': 'name', 'name': 'Currency Name' },
                                { 'key': 'shortName', 'name': 'Currency Short Form' }]}
                                details={currencyDetails}
                                parentValue={customObject(currencyDetails, currencyId)}
                                onChange={(data) => changeCurrency(data.id)}
                                parentError={errorCurrencyId}
                                position={'bottom'}
                                customClasses={classes.margin20t}
                            />
                            <TextField autoComplete='one-time-code'
                                label='Currency Symbol'
                                variant={'standard'}
                                className={clsx(classes.margin20t)}
                                error={errorCurrencySymbol ? true : false}
                                helperText={errorCurrencySymbol}
                                InputProps={{
                                    classes: {
                                        input: classes.textFieldColor,
                                    }
                                }}
                                InputLabelProps={{
                                    className: classes.textFieldLableColorCustom,
                                }}
                                value={currencySymbol}
                                onChange={(e) => setCurrencySymbol(e.target.value)}
                                disabled
                            />
                        </div>
                        <div className={clsx(classes.btnParent)}>
                            <Button
                                key="yes"
                                type='submit'
                                color='primary'
                                variant="contained"
                                className={clsx(classes.modalBtn, { [classes.loading]: editLoader })}
                            >
                                Update & Save
                            </Button>
                        </div>
                    </Box>
                }
            />
            <DeleteModal onClose={(v) => handleDeleteModal(v)} id={countryId} loadTasks={() => loadTasks()} name={countryName} url={'country'} title={'Country'} visible={deleteModal} />
        </>
    );
}